
import { useState, FormEvent } from 'react';

export default function AtelierEmailForm() {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();

    // Basic client‑side validation
    if (!email || !name) {
      setStatus('error');
      return;
    }

    setIsSubmitting(true);
    setStatus('idle');

    try {
      const body = new URLSearchParams();
      body.append('name', name);
      body.append('email', email);
      body.append('type', 'atelier-folio-line');

      const res = await fetch('https://readdy.ai/api/form/d6a214dbiueuoqm1s6dg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });

      if (res.ok) {
        setStatus('success');
        setEmail('');
        setName('');
      } else {
        // Try to read error details for better debugging
        const errorText = await res.text().catch(() => '');
        console.error('Form submission failed:', res.status, errorText);
        setStatus('error');
      }
    } catch (err) {
      console.error('Network or unexpected error:', err);
      setStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="py-16 sm:py-20 bg-[#0F0F0F] relative" aria-labelledby="af-email-heading">
      <div className="max-w-xl mx-auto px-4 sm:px-6">
        <div className="bg-white/[0.03] border border-white/[0.06] rounded-2xl p-6 sm:p-8">
          <div className="text-center mb-6">
            <h2 id="af-email-heading" className="text-lg sm:text-xl font-medium text-white mb-2">
              メールでも情報を受け取る
            </h2>
            <p className="text-xs sm:text-sm text-white/30 font-light">
              LINEをお使いでない方はこちらからご登録ください
            </p>
          </div>

          <form
            id="atelier-folio-email-form"
            data-readdy-form
            onSubmit={handleSubmit}
            className="space-y-4"
          >
            <div>
              <label htmlFor="af-name" className="block text-xs text-white/50 mb-1.5 font-light">
                お名前 <span className="text-rose-400">*</span>
              </label>
              <input
                type="text"
                id="af-name"
                name="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
                autoComplete="name"
                placeholder="山田太郎"
                className="w-full px-4 py-3 text-sm bg-white/5 border border-white/10 rounded-lg text-white placeholder-white/20 focus:outline-none focus:border-[#8E7AB5] focus:ring-1 focus:ring-[#8E7AB5]/30 transition-colors"
              />
            </div>

            <div>
              <label htmlFor="af-email" className="block text-xs text-white/50 mb-1.5 font-light">
                メールアドレス <span className="text-rose-400">*</span>
              </label>
              <input
                type="email"
                id="af-email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="email"
                placeholder="example@email.com"
                className="w-full px-4 py-3 text-sm bg-white/5 border border-white/10 rounded-lg text-white placeholder-white/20 focus:outline-none focus:border-[#8E7AB5] focus:ring-1 focus:ring-[#8E7AB5]/30 transition-colors"
              />
            </div>

            {status === 'success' && (
              <div
                className="p-3 bg-emerald-500/10 border border-emerald-500/20 text-emerald-400 text-xs sm:text-sm rounded-lg text-center"
                role="alert"
              >
                ご登録ありがとうございます！公開時にお知らせいたします。
              </div>
            )}

            {status === 'error' && (
              <div
                className="p-3 bg-rose-500/10 border border-rose-500/20 text-rose-400 text-xs sm:text-sm rounded-lg text-center"
                role="alert"
              >
                エラーが発生しました。もう一度お試しください。
              </div>
            )}

            <button
              type="submit"
              disabled={isSubmitting}
              className="w-full px-6 py-3 bg-white/10 hover:bg-white/15 border border-white/10 text-white text-sm font-light tracking-wide transition-all rounded-lg cursor-pointer whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isSubmitting ? '送信中...' : 'メールで登録する'}
            </button>
          </form>

          <div className="mt-5 pt-5 border-t border-white/[0.06] text-center">
            <p className="text-xs text-white/25 font-light mb-2">
              ※ LINE登録の方が特典が充実しています
            </p>
            <a
              href="https://lin.ee/d6PoCFQ6"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="inline-flex items-center gap-2 text-[#06C755] text-xs sm:text-sm font-medium hover:underline cursor-pointer"
            >
              <i className="ri-line-fill text-base" aria-hidden="true"></i>
              公式LINEで事前登録する
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
